module.exports = __webpack_public_path__ + "img/a2.0c5db5cc.png";